/**
 * Tier helpers (EPIC-07). The API is the real gate: Max-only surfaces answer
 * 403 with code MAX_TIER_REQUIRED, and the portal reacts to that rather than
 * trusting the tier it rendered with.
 */

/**
 * True when an API error is the Max-tier gate. A 403 without a code is treated
 * as the gate too: the Max-only surfaces have no other 403, and the safe
 * response is identical (revert the control, show the upgrade message).
 */
export function isMaxTierError(error: unknown): boolean {
  const response = (error as { response?: { status?: number; data?: { code?: string } } })?.response;
  if (!response || response.status !== 403) return false;
  const code = response.data?.code;
  return !code || code === 'MAX_TIER_REQUIRED';
}
